import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import "../Edit.scss";
import { CustomTable } from "@/hocComponents";

const LinkPaymentTable = forwardRef(({ tableList, tableLoading}, ref) => {
    
    useImperativeHandle(ref, () => ({
      openModal: (type, modalName) => {
      }
    }));

    const initTableHead = {
      remark: undefined,
      checkNo: undefined,
      amount: undefined,
      batch:undefined,
    }

    const [tableHead, setTableHead] = useState(initTableHead);

    const initColumns = [
      {
        title: "Check #",
        dataIndex: "checkNo",
        titleType: "",
        width: 100,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        titleType: "",
        width: 100,
        isAmountFlag: true,
      },
      {
        title: 'Vendor Name',
        dataIndex: "vendorName",
        titleType: '',
        width: 100,
      },
      {
        title: "GL_Title",
        dataIndex: "glTitle",
        titleType: "",
        width: 100,
      },
      {
        title: "Remark",
        dataIndex: "remark",
        titleType: "",
        width: 100,
      },
      {
        title: "Batch",
        dataIndex: "batch",
        titleType: "",
        width: 100,
      },
    ];

    const [columns, setColumns] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);

    const initColunmsFn = () => {
      setTableHead(initTableHead);
      setColumns(initColumns);
    }

    useEffect(() => {
      initColunmsFn()
    }, [refreshKey])

  return (
      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowClassName={(record) => {
          return [record?.rowColorFlag ? 'new-row' : 'old-row']
        }}
        columns={columns}
        tableList={tableList}
        pagination={false}
        tableScroll={{}}
        tableCss="LinkPaymentTable"
      />
  );
});

export default LinkPaymentTable;